{
  "title": "Clients",
  "subtitle": "Les personnes et sociétés à qui vous vendez, retrouvées aussitôt par téléphone, nom ou email.",
  "anonymized": "Client anonymisé",
  "status": {
    "merged": "Fusionné",
    "anonymized": "Anonymisé"
  },
  "types": {
    "person": "Particulier",
    "company": "Société"
  },
  "fields": {
    "type": "Type",
    "name": "Nom complet",
    "companyName": "Raison sociale",
    "contactName": "Personne à contacter",
    "taxId": "Matricule fiscal",
    "phone": "Téléphone",
    "email": "Email",
    "tags": "Étiquettes",
    "notes": "Notes",
    "marketingConsent": "Accepte de recevoir des offres"
  },
  "form": {
    "newTitle": "Nouveau client",
    "newHint": "Un nom suffit au comptoir ; complétez quand vous avez le reste.",
    "editTitle": "Modifier {{number}}",
    "create": "Créer le client",
    "saved": "Client enregistré",
    "created": "Client {{number}} créé",
    "phoneHint": "Les numéros tunisiens n’ont pas besoin du +216.",
    "taxIdHint": "Imprimé sur les factures.",
    "duplicatesTitle": "Déjà client ?",
    "samePhone": "même téléphone {{phone}}",
    "sameEmail": "même email {{email}}",
    "tagsHint": "Des groupes comme VIP, plombier, grossiste. Entrée ou une virgule ajoute une étiquette.",
    "tagsPlaceholder": "Ajouter une étiquette",
    "removeTag": "Retirer l’étiquette {{tag}}",
    "notesHint": "À propos du client, visible par l’équipe seulement.",
    "consentHint": "Seulement avec son accord : vous pourrez alors lui envoyer des offres et des nouvelles."
  },
  "list": {
    "new": "Nouveau client",
    "export": "Exporter vers Excel",
    "search": "Téléphone, nom, email ou numéro",
    "allTypes": "Tous les types",
    "allTags": "Toutes les étiquettes",
    "account": "Compte en ligne",
    "anyAccount": "Avec ou sans compte",
    "withAccount": "Avec un compte en ligne",
    "withoutAccount": "Sans compte en ligne",
    "hasAccount": "A un compte en ligne",
    "sort": "Tri",
    "sorts": {
      "name_asc": "Nom de A à Z",
      "name_desc": "Nom de Z à A",
      "createdAt_desc": "Les plus récents",
      "createdAt_asc": "Les plus anciens"
    },
    "clear": "Effacer les filtres",
    "showing_one": "{{first}}–{{last}} sur {{total}} client",
    "showing_other": "{{first}}–{{last}} sur {{total}} clients"
  },
  "columns": {
    "customer": "Client",
    "city": "Ville"
  },
  "empty": {
    "title": "Aucun client pour le moment",
    "text": "Enregistrez les personnes et sociétés à qui vous vendez : leur téléphone les retrouve au comptoir, leurs adresses servent aux livraisons."
  },
  "noMatch": {
    "title": "Aucun client trouvé",
    "text": "Vérifiez le numéro ou l’orthographe, ou enregistrez un nouveau client."
  },
  "addresses": {
    "title": "Adresses",
    "add": "Ajouter",
    "addTitle": "Nouvelle adresse",
    "editTitle": "Modifier l’adresse",
    "none": "Aucune adresse pour le moment.",
    "untitled": "Adresse",
    "label": "Nom",
    "labelHint": "Domicile, boutique, chantier…",
    "recipient": "Destinataire",
    "line1": "Adresse",
    "line2": "Complément d’adresse",
    "city": "Ville",
    "postalCode": "Code postal",
    "governorate": "Gouvernorat",
    "phone": "Téléphone à cette adresse",
    "phoneHint": "Pour la livraison, s’il diffère de celui du client.",
    "defaultDelivery": "Adresse de livraison par défaut",
    "defaultBilling": "Adresse de facturation par défaut",
    "delivery": "Livraison",
    "billing": "Facturation",
    "saved": "Adresse enregistrée",
    "remove": "Retirer",
    "removeTitle": "Retirer cette adresse ?",
    "removed": "Adresse retirée"
  },
  "merge": {
    "action": "Fusionner un autre client ici",
    "title": "Fusionner un client dans {{number}}",
    "hint": "Choisissez le doublon. Il rejoint ce client, qui garde ses propres données.",
    "search": "Client à fusionner",
    "duplicates": "Même téléphone ou email",
    "typeToSearch": "Recherchez l’autre client par téléphone, nom, email ou numéro.",
    "summaryTitle": "Ce qui se passe",
    "summary": "Les données qui manquent à ce client, les adresses, étiquettes, notes, le compte en ligne et l’historique de {{source}} arrivent ici. {{source}} renvoie ensuite ici et ne peut plus être modifié.",
    "confirm": "Fusionner",
    "done": "{{source}} fusionné dans {{target}}"
  },
  "timeline": {
    "title": "Historique",
    "hint": "Modifications, notes et demandes, les plus récentes d’abord, avec les commandes.",
    "kindLabel": "Type d’entrée",
    "kinds": {
      "note": "Note",
      "request": "Demande"
    },
    "notePlaceholder": "Ce que l’équipe doit savoir",
    "requestPlaceholder": "Ce que le client a demandé",
    "addNote": "Ajouter la note",
    "addRequest": "Ajouter la demande",
    "noteAdded": "Note ajoutée",
    "requestAdded": "Demande ajoutée",
    "personal": "Modifié : {{fields}}",
    "personalEntered": "Saisi : {{fields}}",
    "theCustomer": "Le client",
    "empty": "Rien pour le moment.",
    "more": "Afficher {{count}} de plus"
  },
  "account": {
    "title": "Compte en ligne",
    "badge": "Compte en ligne",
    "none": "Pas de compte en ligne. Les clients créent le leur sur la boutique en ligne.",
    "status": "Adresse email",
    "verified": "Confirmée",
    "pending": "Pas encore confirmée",
    "created": "Créé le",
    "lastSignIn": "Dernière connexion",
    "passwordLink": "Lien de mot de passe",
    "linkTitle": "Lien pour choisir un nouveau mot de passe",
    "linkText": "Envoyez-le au client, par message par exemple. Il fonctionne une fois, pendant {{minutes}} minutes, et ferme les autres sessions du client.",
    "copy": "Copier le lien",
    "copied": "Lien copié"
  },
  "page": {
    "more": "Plus d’actions",
    "contact": "Coordonnées",
    "yes": "Oui",
    "no": "Non",
    "created": "Créé",
    "lastChange": "Dernière modification",
    "dateBy": "{{date}} par {{name}}",
    "mergedTitle": "Fusionné",
    "mergedText": "Ce client a été fusionné dans",
    "anonymizedTitle": "Anonymisé",
    "anonymizedText": "Ses données personnelles ont été supprimées le {{date}}, à sa demande.",
    "duplicatesTitle_one": "Un doublon possible",
    "duplicatesTitle_other": "{{count}} doublons possibles",
    "same": {
      "phone": "même téléphone",
      "email": "même email"
    },
    "mergeHere": "Fusionner ici",
    "newOrder": "Nouvelle commande",
    "recordPayment": "Enregistrer un paiement"
  },
  "anonymize": {
    "action": "Anonymiser",
    "title": "Anonymiser {{number}} ?",
    "text": "Son nom, téléphone, email, matricule fiscal, ses adresses, étiquettes, notes et son compte en ligne sont supprimés définitivement, y compris des clients fusionnés avec lui. Ses commandes restent, sans données personnelles. C’est irréversible.",
    "confirm": "Anonymiser",
    "done": "{{number}} anonymisé"
  },
  "delete": {
    "action": "Supprimer",
    "title": "Supprimer {{number}} ?",
    "text": "Ce client n’a jamais été utilisé : il est supprimé définitivement. Le journal d’activité garde une trace de la suppression.",
    "confirm": "Supprimer",
    "done": "{{number}} supprimé"
  },
  "tabs": {
    "orders": "Commandes",
    "payments": "Paiements",
    "timeline": "Historique",
    "details": "Détails"
  },
  "figures": {
    "open": "Reste à payer",
    "openOrders_one": "Sur {{count}} commande",
    "openOrders_other": "Sur {{count}} commandes",
    "total": "Commandé",
    "orders_one": "{{count}} commande",
    "orders_other": "{{count}} commandes",
    "paid": "Payé",
    "refunded": "Remboursé"
  },
  "orders": {
    "empty": "Pas encore de commande.",
    "order": "Commande",
    "date": "Date",
    "status": "Statut",
    "payment": "Paiement",
    "total": "Total",
    "paid": "Payé",
    "due": "Reste dû"
  },
  "payments": {
    "empty": "Pas encore de paiement.",
    "date": "Date",
    "method": "Moyen",
    "pays": "Paie",
    "amount": "Montant",
    "status": "Statut",
    "received": "Reçu",
    "showing_one": "{{first}}–{{last}} sur {{total}} paiement",
    "showing_other": "{{first}}–{{last}} sur {{total}} paiements"
  }
}
